<div class="screen-container feature-content fx-column fx-start-stretch">
	<div class="screen-header" #contentHeader>
		<ng-container *ngIf="headerLoader">
			<!-- <div class="shimmer loader" fxLayout="column" fxLayoutAlign="start stretch">
				<div class="bg-active" fxFlex="5px"></div>
				<div fxFlex="32px" fxLayout="row" fxLayoutAlign="space-between stretch">
					<div fxFlex="50px" class="thumbnail-circle"></div>
					<div class="bg-active" fxFlex="10px"></div>
					<div fxFlex="1 1 90%" fxFlex.xs="1 1 100%" fxLayout="column" fxLayoutAlign="start stretch">
						<div class="bg-active" fxFlex="5px"></div>
						<div fxFlex="10px" fxLayout="row" fxLayoutAlign="start stretch">
							<div fxFlex="1 1 60%"></div>
							<div class="bg-active" fxFlex="1 1"></div>
						</div>
						<div class="bg-active" fxFlex="5px"></div>
						<div fxFlex="10px" fxLayout="row" fxLayoutAlign="start stretch">
							<div fxFlex="1 1"></div>
							<div class="bg-active" fxFlex="1 1 30px"></div>
						</div>
						<div class="bg-active" fxFlex="1 1"></div>
					</div>
					<div class="bg-active" fxFlex="1 1 40%" fxFlex.xs="1 1 10%"></div>
				</div>
				<div class="bg-active" fxFlex="1 1"></div>
			</div> -->
		</ng-container>

		<ng-container *ngIf="!headerLoader">
			<ng-content select="content-header"></ng-content>
		</ng-container>

	</div>
	<div class="screen-content fx-column fx-start-stretch fx-no-grow fx-shrink">
		<div class="screen-content-body" #contentArea
			[ngClass]="{'fx-row fx-space-between-start' : detectDevice?.resolutionState$?.value?.deviceType !== 'mobile', 'fx-column fx-start-stretch' : detectDevice?.resolutionState$?.value?.deviceType === 'mobile', 'after-loading' : !contentLoader}">

			<!-- <ng-container [ngTemplateOutlet]="feature" *ngIf="!isMobile"></ng-container> -->
			<!-- <ng-template #feature> -->
			<ng-container *ngIf="featureLoader || featuresArr?.length">
				<div class="features"
					[ngClass]="{'fx-column fx-start-stretch fx-no-grow fx-no-shrink' : detectDevice?.resolutionState$?.value?.deviceType !== 'mobile', 'fx-column fx-start-stretch fx-no-grow fx-no-shrink mView' : detectDevice?.resolutionState$?.value?.deviceType === 'mobile'}"
					#feature>
					<!-- <div class="feature-toggle">
								<mat-icon>arrow_left</mat-icon>
							</div> -->
					<!-- loader -->
					<ng-container *ngIf="featureLoader">
						<div class="shimmer loader" fxLayout="column" fxLayoutAlign="start stretch">
							<div fxLayout="column" fxLayoutAlign="start stretch">
								<div class="bg-active" fxFlex="10px"></div>
								<div fxFlex="10px" fxLayout="row" fxLayoutAlign="start stretch">
									<div class="bg-active" fxFlex="20px"></div>
									<div fxFlex="1 1"></div>
									<div class="bg-active" fxFlex="20px"></div>
								</div>
								<div class="bg-active" fxFlex="10px"></div>
								<div class="thumbnail-circle"></div>
								<div class="loader-content" fxLayout="row" fxLayoutAlign="space-between stretch">
									<div class="bg-active" fxFlex="10px"></div>
									<div fxFlex="1 1" fxLayout="column" fxLayoutAlign="start stretch">
										<div class="bg-active" fxFlex="5px"></div>
										<div fxFlex="10px" fxLayout="row" fxLayoutAlign="start stretch">
											<div class="bg-active" fxFlex="30px"></div>
											<div fxFlex="1 1"></div>
											<div class="bg-active" fxFlex="30px"></div>
										</div>
										<div class="bg-active" fxFlex="5px"></div>
										<div fxFlex="10px" fxLayout="row" fxLayoutAlign="start stretch">
											<div class="bg-active" fxFlex="20px"></div>
											<div fxFlex="1 1"></div>
											<div class="bg-active" fxFlex="20px"></div>
										</div>
										<div class="bg-active" fxFlex="20px"></div>
									</div>
									<div class="bg-active" fxFlex="10px"></div>
								</div>
							</div>
							<mat-divider></mat-divider>
							<div fxLayout="column" fxLayoutAlign="start stretch">
								<div class="bg-active" fxFlex="10px"></div>
								<div fxFlex="10px" fxLayout="row" fxLayoutAlign="start stretch">
									<div class="bg-active" fxFlex="20px"></div>
									<div fxFlex="1 1"></div>
									<div class="bg-active" fxFlex="20px"></div>
								</div>
							</div>
							<div class="bg-active" fxFlex="1 1"></div>
						</div>
					</ng-container>
					<!-- loader -->
					<ng-container *ngIf="featuresArr?.length">
						<ng-container *ngIf="detectDevice?.resolutionState$?.value?.deviceType === 'mobile'">
							<app-readability [height]="'55'">
								<content>
									<ng-container [ngTemplateOutlet]="featureGroup"></ng-container>
								</content>
							</app-readability>
						</ng-container>
						<ng-container *ngIf="detectDevice?.resolutionState$?.value?.deviceType !== 'mobile'"
							[ngTemplateOutlet]="featureGroup"></ng-container>
						<ng-template #featureGroup>
							<div class="feature-group "
								[ngClass]="{'fx-column fx-start-stretch' : detectDevice?.resolutionState$?.value?.deviceType !== 'mobile', 'fx-column fx-start-stretch fx-grow fx-shrink' : detectDevice?.resolutionState$?.value?.deviceType === 'mobile'}">
								<!-- <ng-container *ngIf="features?.title">
									<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="12px">
										<div fxLayoutAlign="center center">
											<div class="sub-txt-patch">
												{{features?.title}}
											</div>
										</div>
									</div>
								</ng-container> -->
								<div class="feature-container fx-column fx-start-stretch fx-grow fx-shrink ">
									<div class="feature-list fx-column fx-start-stretch"
										[ngClass]="{'xs' : detectDevice?.resolutionState$?.value?.xs}">
										<ng-container *ngFor="let feature of featuresArr; let isLast=last">
											<ng-container [ngSwitch]="feature.key">
												<ng-container *ngSwitchCase="'author'">
													<div class="feature-item author-format"
														[ngClass]="{'fx-column fx-center-stretch' : detectDevice?.resolutionState$?.value?.deviceType !== 'mobile', 'fx-row fx-center-center' : detectDevice?.resolutionState$?.value?.deviceType === 'mobile'}">
														<div class="item-content fx-column fx-start-stretch"
															*ngIf="feature?.value?.imageSrc || feature?.value?.name || feature?.value?.createdAt">
															<div class="profile-feature fx-column fx-center-center">
																<ng-container *ngIf="feature?.value?.imageSrc">
																	<div class="profile">
																		<ng-container *ngIf="feature?.value?.imageSrc">
																			<img [src]="feature?.value?.imageSrc" (click)="profileInfo()"
																				(error)="gfService.setErrorImage($event, 'man')"
																				class="thumbnail cursor-pointer">
																		</ng-container>
																		<!-- <ng-container *ngIf="!feature?.value?.imageSrc">
																			<img src="assets/img/man.png" (click)="profileInfo()"
																				(error)="gfService.setErrorImage($event, 'man')"
																				class="thumbnail cursor-pointer">
																		</ng-container> -->
																		<!-- <mat-icon class="silver-icon" svgIcon="badge"></mat-icon> -->
																	</div>
																</ng-container>
																<ng-container *ngIf="feature?.value?.createdAt || feature?.value?.name">
																	<div class="sub-content"
																		[ngClass]="{'fx-column fx-center-center' : detectDevice?.resolutionState$?.value?.deviceType !== 'mobile', 'fx-row-wrap fx-center-center' : detectDevice?.resolutionState$?.value?.deviceType === 'mobile'}">
																		<div *ngIf="feature?.value?.name">
																			<p class="sub-text-1 manage-gap cursor-pointer">
																				<span (click)="profileInfo()">{{feature?.value?.name}}</span>
																				<ng-container *ngIf="feature?.value?.count">
																					<span (click)="usersInfo()"> +
																						{{feature?.value?.count}} </span>
																				</ng-container>
																			</p>
																		</div>
																		<div *ngIf="feature?.value?.createdAt">
																			<p class="sub-caption-1 fx-center-center">
																				{{feature?.value?.createdAt}}</p>
																		</div>
																	</div>
																</ng-container>
															</div>
														</div>
													</div>
													<mat-divider></mat-divider>
												</ng-container>
												<ng-container *ngSwitchCase="'rating'">
													<div class="feature-item feature-format fx-column fx-center-center">
														<div class="item-content"
															[ngClass]="{'fx-column fx-center-center':detectDevice?.resolutionState$?.value?.deviceType !== 'mobile', 'fx-row-wrap fx-center-center':detectDevice?.resolutionState$?.value?.deviceType === 'mobile'}">
															<div class="fx-row-wrap fx-center-center">
																<app-mat-rating [field]="ratingField" [formControl]="ratingControl"
																	[control]="ratingControl" class="rating-control fx-center-center">
																</app-mat-rating>
																<ng-container *ngIf="![null, undefined].includes(feature?.value?.count)">
																	<span class="rating-count">({{feature?.value?.count}})</span>
																</ng-container>
															</div>
															<ng-container *ngIf="!ratingField?.isReadonly">
																<div class="sub-caption-1 gap-rating fx-center-center">
																	<p> {{locale.translate('click_to_rate')}}</p>
																</div>
															</ng-container>
														</div>
													</div>
													<mat-divider></mat-divider>
												</ng-container>
												<ng-container *ngSwitchCase="'feature'">
													<ng-container *ngIf="feature?.value?.data?.length">
														<div class="feature-item feature-format fx-column fx-start-stretch">
															<div class="item-content fx-grow fx-shrink fx-column fx-start-stretch">
																<div class="use fx-grow fx-shrink fx-row fx-center-center">
																	<app-manage [data]="feature?.value?.data" (manage)="manageInfo($event)">
																	</app-manage>
																</div>

															</div>
														</div>
														<mat-divider></mat-divider>
													</ng-container>
												</ng-container>
												<ng-container *ngSwitchCase="'assignment'">
													<ng-container *ngIf="feature?.value?.data?.length">
														<div class="feature-item feature-format fx-column fx-start-stretch">
															<div class="item-content fx-grow fx-shrink fx-column fx-center-center">
																<div class="button-block fx-row-wrap fx-center-center">
																	<ng-container *ngFor="let data of feature?.value?.data">
																		<ng-container *ngIf="data?.type === 'action-button'">
																			<button mat-stroked-button #assignmentBtn class="submit-btn"
																				[ngClass]="data?.classes"
																				(click)="assignmentChanges({'actionElement': assignmentBtn, 'data': data})">
																				{{data?.caption}}
																			</button>
																		</ng-container>
																		<ng-container *ngIf="data?.type === 'cancel-button'">
																			<button mat-button #assignmentBtn class="cancel-btn" [ngClass]="data?.classes"
																				(click)="assignmentChanges({'actionElement': assignmentBtn, 'data': data})">
																				{{data?.caption}}
																			</button>
																		</ng-container>
																		<ng-container *ngIf="data?.type === 'sub-action-button'">
																			<button mat-stroked-button #assignmentBtn class="sub-submit-btn"
																				[ngClass]="data?.classes"
																				(click)="assignmentChanges({'actionElement': assignmentBtn, 'data': data})">
																				{{data?.caption}}
																			</button>
																		</ng-container>
																		<ng-container *ngIf="data?.type === 'sub-cancel-button'">
																			<p class="manage-link" #assignmentBtn [ngClass]="data?.classes"
																				(click)="assignmentChanges({'actionElement': assignmentBtn, 'data': data})">
																				{{data?.caption}}</p>
																		</ng-container>
																	</ng-container>
																</div>
															</div>
														</div>
														<mat-divider></mat-divider>
													</ng-container>
												</ng-container>
												<ng-container *ngSwitchCase="'stats'">
													<div class="feature-item feature-format fx-column fx-start-stretch">
														<div class="item-content fx-grow fx-shrink fx-column fx-start-stretch">
															<div class="stats fx-grow fx-shrink fx-row-wrap fx-center-center">
																<app-stats [stats]="feature?.value"></app-stats>
															</div>
														</div>
													</div>
													<!-- <mat-divider></mat-divider> -->
												</ng-container>
												<!-- <ng-container *ngSwitchCase="'manage'">
														<ng-container *ngIf="feature?.value?.data?.length">
															<div class="feature-item feature-format fx-column fx-start-stretch">
																<div class="item-content fx-column fx-start-stretch">
																	<div class="manage fx-row-wrap fx-center-center">
																		<app-manage [data]="feature?.value?.data" (manage)="manageInfo($event)"></app-manage>
																	</div>
																</div>
															</div>
															<mat-divider></mat-divider>
														</ng-container>
													</ng-container> -->
											</ng-container>
											<!-- <mat-divider *ngIf="!isLast"></mat-divider> -->
										</ng-container>
										<!-- <mat-divider
											*ngIf="features?.author && (features?.rating || features?.feature || features?.assignment || features?.stats || features?.manage)">
										</mat-divider>

										<mat-divider
											*ngIf="features?.rating && (features?.feature || features?.assignment || features?.stats || features?.manage)">
										</mat-divider>
										<mat-divider *ngIf="features?.feature && (features?.assignment || features?.stats || features?.manage)">
										</mat-divider>
										<mat-divider *ngIf="features?.assignment && (features?.stats || features?.manage)">
										</mat-divider>
										<mat-divider *ngIf="features?.stats && features?.manage"></mat-divider> -->

									</div>

								</div>
								<!-- <div class="feature-footer fx-column fx-start-stretch">
									<div class="problem-content sub-caption-1 fx-center-center">
										<mat-icon>block</mat-icon><span>{{locale.translate('problem_content')}}</span>
									</div>
								</div> -->
							</div>
						</ng-template>
					</ng-container>
				</div>
			</ng-container>
			<!-- </ng-template> -->
			<div class="screen-blocks fx-column fx-start-stretch fx-grow fx-shrink">
				<loader [loader]="contentLoader" [type]="'general'" [classes]=""></loader>
				<div class="fx-column fx-start-stretch">
					<div class="fx-row-wrap fx-start-center">
						<ng-container *ngIf="featuresArr?.length">
							<ng-container *ngIf="features?.title">
								<div class="fx-row fx-start-start">
									<div class="sub-txt-patch">
										{{features?.title}}
									</div>
									<ng-container
										*ngIf="additionalData && additionalData.readTime && [null, undefined, 0].includes(additionalData.read)">
										<div class="reading-time-calc  sub-caption-2"
											[innerHtml]="locale.translate('approx_read_time') | handleBar : { 'time' : additionalData.readTime }">
										</div>
									</ng-container>
									<!-- <ng-container *ngIf="additionalData && additionalData.read === 1">
									<div class="sub-txt-patch success no-cap">
										<ng-container *ngIf="additionalData && ['page', 'link'].includes(additionalData.resourceFormat)">
											{{locale.translate('you_have_seen_this')}}
										</ng-container>
										<ng-container *ngIf="additionalData && ['video', 'audio'].includes(additionalData.resourceFormat)">
											{{locale.translate('you_have_watched_this')}}
										</ng-container>
										<ng-container *ngIf="additionalData && ['document'].includes(additionalData.resourceFormat)">
											{{locale.translate('you_have_read_this')}}
										</ng-container>
										<ng-container *ngIf="additionalData && ['playlist'].includes(additionalData.resourceType)">
											{{locale.translate('you_have_read_this')}}
										</ng-container>
									</div>
								</ng-container> -->
									<ng-container *ngIf="additionalData && additionalData.read === 1">
										<div class="tick-icon">
											<mat-icon svgIcon="tick_mark"></mat-icon>
										</div>
									</ng-container>
								</div>
							</ng-container>
						</ng-container>
						<ng-container
							*ngIf="additionalData && [null, undefined, 0, false].includes(additionalData.read) && ![null, undefined].includes(progress)">
							<div class="progress-state fx-column fx-start-stretch fx-no-grow fx-shrink">
								<mat-progress-bar [value]="progress" color="primary" mode="determinate"></mat-progress-bar>
							</div>
						</ng-container>
					</div>
					<div class="title-section fx-row fx-space-between-center">
						<h1 class="screen-title">
							<ng-content select="classic-content-title"></ng-content>
						</h1>
						<ng-container *ngIf="optionMenu?.length">
							<div class="resource-option">
								<button mat-icon-button [matMenuTriggerFor]="menu">
									<mat-icon>more_vert</mat-icon>
								</button>
								<mat-menu #menu="matMenu">
									<ng-container *ngFor="let option of optionMenu">
										<button mat-menu-item [ngClass]="option?.classes" (click)="optionAction(option)"
											[disabled]="option?.disabled">
											<ng-container *ngIf="option?.icon">
												<mat-icon>{{option?.icon}}</mat-icon>
											</ng-container>
											<span>{{option?.caption}}</span>
										</button>
									</ng-container>
								</mat-menu>
							</div>
						</ng-container>
					</div>
				</div>
				<div class="classic-content-area fx-column fx-start-stretch fx-grow fx-shrink">
					<ng-content select="content-area"></ng-content>
				</div>
			</div>
		</div>
	</div>
</div>
